module.exports = __webpack_public_path__ + "static/img/6_IMG_20151229_114957.bf2d985d.jpg";